import { sort } from "shared/lib/arrayUtils"
import { Project } from "shared/types/Project"
import { SortOrder } from "shared/types/SortOrder"

function sortProjectsByDate(
  projects: Project[],
  property: "createdAt" | "lastChanged",
  direction: SortOrder
) {
  return sort(
    projects,
    (a, b) =>
      new Date(b[property] ?? "").getTime() -
      new Date(a[property] ?? "").getTime(),
    direction
  )
}

export function sortProjectsByCreatedAt(
  projects: Project[],
  direction: SortOrder
) {
  return sortProjectsByDate(projects, "createdAt", direction)
}
export function sortProjectsByUpdatedAt(
  projects: Project[],
  direction: SortOrder
) {
  return sortProjectsByDate(projects, "lastChanged", direction)
}

export function sortProjectsAlphabetically(
  projects: Project[],
  direction: SortOrder
) {
  return sort(projects, (a, b) => (a.title <= b.title ? -1 : 1), direction)
}
